import { RootInjectorGuard } from '../guards/root-injector.guard'
import { Injectable, inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { ErrorService } from './error.service'
import { catchError, Observable } from 'rxjs'
import { environment } from '../../environments/environment'
import { NapcsCode } from '../types/plastics'

@Injectable({
  providedIn: 'root',
})
export class NapcsCodeService extends RootInjectorGuard {
  private http = inject(HttpClient)
  private errorService = inject(ErrorService)

  private URL = environment.baseUrl + 'napcs-codes'

  constructor() {
    super(NapcsCodeService)
  }

  getAll(): Observable<Array<NapcsCode>> {
    return this.http
      .get<Array<NapcsCode>>(this.URL)
      .pipe(catchError(this.errorService.handleError))
  }
}
